import { SuccessmodalPageModule } from './pages/successmodal/successmodal.module';
import { APP_INITIALIZER, NgModule, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StorageService } from './services/storage.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { httpInterceptorProviders } from './interceptors/interceptor.service';
import { appInitializer } from 'src/app/helpers/app.initializer';
import { AutService } from './auth/aut.service';
import { FunctionsService } from './helpers/functions.service';

import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        SuccessmodalPageModule,
        HttpClientModule,
        IonicStorageModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        NgxGoogleAnalyticsModule.forRoot(environment.ga),
        NgxGoogleAnalyticsRouterModule.forRoot({ include: [ '/*' ] })
    ],
    providers: [
        StorageService,
        { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AutService, FunctionsService, StorageService] },
        StatusBar,
        SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        httpInterceptorProviders
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    static injector: Injector;
    constructor(public injector: Injector) {
        AppModule.injector = injector;
    }
}
